import React, { Component } from 'react'
import './idleTimerView.Style.css';

class IdleTimerViewComponent extends Component {
  componentDidMount() {
    localStorage.removeItem('user');
    localStorage.removeItem('_expiredTime');
    setTimeout(()=> {
      window.location.reload();
    }, 3000);
  }
  render() {

    return (
      <div className="page-wrapper">
        <div className="page-header"></div>
        <div className="page-content">
          <div className="page-title">
            <h1 className="home-title">Uw sessie is verlopen</h1>
          </div>
          <div className="page-inner-content-home">
            <div className="page-inner-content-idle-timer">
              <p>
                U dient opnieuw in te loggen. Excuses voor het ongemak. 
              </p>
              <p>
                U wordt automatisch doorverwezen.
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default IdleTimerViewComponent;
